<template>
    <div>
      <national-trademark-application-type-list></national-trademark-application-type-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
  